import { PageContainer } from "app/pages/industry-analysis/common/styledComponents";

import { KeywordsBreakdownWidget } from "../keywords-breakdown-widget";
import { SearchVolumeOverTimeWidget } from "../search-volume-over-time-widget";
import { TrafficByCountry } from "../traffic-by-country";

import { DemandOverTime } from "./demand-over-time/DemandOverTime";

const SearchTrendsKeywordsPoP = () => {
    return (
        <>
            <PageContainer>
                <SearchVolumeOverTimeWidget />
            </PageContainer>
            <TrafficByCountry />
            <DemandOverTime />
            <KeywordsBreakdownWidget isPeriodOverPeriod />
        </>
    );
};

export default SearchTrendsKeywordsPoP;
